import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef } from '@angular/core';
import { RestDataService } from '../../service/rest-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { Config } from '../../config/config';
import index from 'quill';

@Component({
  selector: '.related-story-view',
  templateUrl: './related-story-view.component.html',
  styleUrls: ['./related-story-view.component.scss']
})
export class RelatedStoryViewComponent implements OnInit {

  story = null;
  showOptions = false;

  page_id = StaticDataService.story_page_id;
  save_api = StaticDataService.story_save_api;
  get_api = StaticDataService.story_get_api;
  @Input() storyId: number;
  @Input() alsoRead: true;
  @Input() arrayIndex: number;
  @Input() editMode: boolean;
  @Input() relatedStoryType: string;
  @Input() headline: string;
  @Output() deleteRelatedStoryfn = new EventEmitter<any>();
  @Output() updateAlsoReadHeadline = new EventEmitter<any>();
  @Output() replaceRelatedStoryfn = new EventEmitter<any>();
  @Output() receivedRelatedStoryHeadline = new EventEmitter<any>();

  @ViewChild('opts', {static: false}) optionRef: ElementRef;
  @ViewChild('opts2', {static: false}) optionRef2: ElementRef;
  newHeading: any;
  editFlag: boolean;

  constructor(
    private config: Config,
    private restService: RestDataService
  ) { }

  ngOnInit() {
    if (this.storyId) {
      this.restService.http_get(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api)
        + '/' + this.storyId)
        .subscribe(
          data => {
            this.story = data;
            if(this.relatedStoryType=='gallery'){
              console.log( this.story);
              this.receivedRelatedStoryHeadline.emit(this.story.headline)
            }
          },
          error => {
            // console.log(error);
          });
    }
  }

  @HostListener('window:keydown', ['$event'])
  public hotkeys($event) {
    // console.log(this.focusElement);
    const key = $event.keyCode || $event.charCode;

    if (key === 27) {
      this.showOptions = false;
    }

  }

  @HostListener('window:click', ['$event'])
  public hotclicks($event) {
    // console.log($event);
    // const key = $event.keyCode || $event.charCode;
    const clickedComponent = $event.target;
    if (
      !(
        (this.optionRef && (this.optionRef.nativeElement as HTMLElement).contains(clickedComponent))
        || (this.optionRef2 && (this.optionRef2.nativeElement as HTMLElement).contains(clickedComponent))
      )
    ) {
      this.showOptions = false;
    }
    // if (key === 27) {
    //   this.showOptions = false;
    // }

  }

  closeOptions() {
    this.showOptions = false;
  }

  saveHeadline(ev) {
    const key = ev.keyCode || ev.charCode;
    if (key === 13) {
      ev.preventDefault();
      this.editFlag = false;
      this.updateAlsoReadHeadline.emit({
        id: this.storyId,
        index: this.arrayIndex,
        newHeading : this.newHeading
      });
    }
  }
  
  triggerEdit() {
    this.editFlag = true;
    this.newHeading = this.headline ? this.headline : this.story.mobileHeadline;
  }

  triggerReplace() {
    this.replaceRelatedStoryfn.emit({
      id: this.storyId,
      index: this.arrayIndex
    });
  }

  triggerDelete() {
    this.deleteRelatedStoryfn.emit({
      id: this.storyId,
      index: this.arrayIndex
    });
  }

}
